import SettingService from '@/services/settingservice'
import store from '@/store'

export default {
  formatMoney (amount, decimalCount = 0, decimal = '.', thousands = ',') {
    try {
      decimalCount = Math.abs(decimalCount)
      decimalCount = isNaN(decimalCount) ? 2 : decimalCount
      const negativeSign = amount < 0 ? '-' : ''
      let i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString()
      let j = (i.length > 3) ? i.length % 3 : 0
      return negativeSign + (j ? i.substr(0, j) + thousands : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, '$1' + thousands) + (decimalCount ? decimal + Math.abs(amount - i).toFixed(decimalCount).slice(2) : '')
    } catch (e) {
      console.log(e)
    }
  },
  transformNull (data, reverse = false) {
    const newObj = {}
    if (reverse) {
      Object.keys(data).forEach((key, index) => {
        if (data[key] === null) {
          newObj[key] = ''
        } else {
          newObj[key] = data[key]
        }
      })
    } else {
      Object.keys(data).forEach((key, index) => {
        if (data[key] === '') {
          newObj[key] = null
        } else {
          newObj[key] = data[key]
        }
      })
    }
    return newObj
  },
  isEmptyObj (obj) {
    return Object.keys(obj).length === 0
  },
  async getSellerInfo () {
    await SettingService.getSellerInformation()
      .then(response => {
        store.commit('setUser', response.seller)
      })
  },
  chunkArray (myArray, chunkSize) {
    let results = []
    while (myArray.length) {
      results.push(myArray.splice(0, chunkSize))
    }
    return results
  },
  delay (time) {
    return new Promise(resolve => setTimeout(resolve, time))
  }
}

export function replaceHTMLSellerInfo (html) {
  if (!html) {
    return ''
  }
  const sellerId = store.getters.getUser.sellerId
  const sellerName = store.getters.getUser.sellerName
  const companyName = store.getters.getUser.companyName
  const chatWorkRoomId = store.getters.getUser.chatWorkRoomId || ''
  const noticeEmail = store.getters.getUser.noticeEmail || ''

  return html
    .replace(/{{sellerid}}/g, sellerId)
    .replace(/{{sellername}}/g, sellerName)
    .replace(/{{companyname}}/g, companyName)
    .replace(/{{chatworkroomid}}/g, chatWorkRoomId)
    .replace(/{{noticeemail}}/g, noticeEmail)
}



// WEBPACK FOOTER //
// ./src/common/utility.js